<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品销售情况表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-date-picker
      v-model="reportProductSaleRequest.startYear"
      type="year"
      size="mini"
      value-format="yyyy"
      placeholder="选择开始年份">
    </el-date-picker>
    <el-date-picker
      v-model="reportProductSaleRequest.endYear"
      type="year"
      size="mini"
      value-format="yyyy"
      placeholder="选择结束年份">
    >
    </el-date-picker>
    <el-select v-model="selectProductType" clearable value filterable placeholder="请选择产品类别"
               style="margin-left: 5px;width: 200px" size="mini" @change="getProductType">
      <el-option
        v-for="org in productTypes"
        :key="org.id"
        :label="org.productTypeName"
        :value="org.productTypeName">
      </el-option>
    </el-select>
    <el-select v-model="selectProduct" clearable value filterable placeholder="请选择产品名称"
               style="margin-left: 5px;width: 200px" size="mini" @change="getProduct">
      <el-option
        v-for="orgCost in products"
        :key="orgCost.id"
        :label="orgCost.productName"
        :value="orgCost.productName">
      </el-option>
    </el-select>
    <el-select v-model="selectInOrgId" clearable value filterable placeholder="请选择领用人"
               style="margin-left: 5px;width: 200px" size="mini" @change="getInOrgId">
      <el-option
        v-for="orgCost in shops"
        :key="orgCost.id"
        :label="orgCost.orgName"
        :value="orgCost.id">
      </el-option>
    </el-select>
    <el-button size="mini" style="margin-left: 5px;" @click="loadProductSaleList">查询</el-button>
    <el-table height="550px" :data="productSales" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}"
              :show-summary="true">
      <el-table-column
        align="center"
        prop="year"
        width="120"
        label="年份">
      </el-table-column>
      <el-table-column
        align="center"
        prop="orgName"
        width="140"
        label="机构">
      </el-table-column>
      <el-table-column
        align="center"
        prop="one"
        label="1月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="two"
        label="2月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="three"
        label="3月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="four"
        label="4月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="five"
        label="5月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="six"
        label="6月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="seven"
        label="7月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="eight"
        label="8月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="nine"
        label="9月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="ten"
        label="10月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="eleven"
        label="11月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="twolve"
        label="12月">
      </el-table-column>
      <el-table-column
        align="center"
        prop="hj"
        label="合计">
      </el-table-column>
      <el-table-column
        align="center"
        prop="rate"
        label="销售占比">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgId:'',
      userId:'',
      userName:'',
      orgLevel:'',
      authorities:'',
      shops:[],
      productSales:[],
      productTypes:[],
      products:[],
      selectProductType:'',
      selectProduct:'',
      selectInOrgId:'',
      reportProductSaleRequest:{
        orgId:'',
        startYear:'',
        endYear:'',
        productType:'',
        productName:'',
        inOrgId:'',
        outOrgId:''
      }
    }
  },
  methods:{
    getInOrgId(data){
      this.reportProductSaleRequest.inOrgId = data;
    },
    getProductType(data){
      this.reportProductSaleRequest.productType = data;
    },
    getProduct(data){
      this.reportProductSaleRequest.productName = data;
    },
    async loadProductType(){
      const {data:res} = await this.$http.get(`/load/product/type/list`);
      if (res.code === 200){
        this.productTypes = res.data;
      }
    },
    async loadProduct(){
      const {data:res} = await this.$http.get(`/load/product`);
      if (res.code === 200){
        this.products = res.data;
      }
    },
    async loadShops(){
      const {data:res} = await this.$http.get(`orgs/area/orgId/${this.orgId}`);
      if (res.code === 200){
        this.shops = res.data;
      }
    },
    async loadProductSaleList(){
      // if(this.selectOrgId !== ''){
      //   this.reportProductSaleRequest.inOrgId = this.selectOrgId;
      // }
      if (this.reportProductSaleRequest.startYear == ''){
        return this.$message.warning("请选择开始年份");
      }
      if (this.reportProductSaleRequest.endYear == '') {
        return this.$message.warning("请选择结束年份");
      }
      const {data:res} = await this.$http.post(`/report/product/sale`, this.reportProductSaleRequest);
      if (res.code === 200){
        this.productSales = res.data;
      }
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.reportProductSaleRequest.outOrgId = this.orgId;
    this.loadProductType();
    this.loadProduct();
    this.loadShops();
  }


}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportProductSale.vue